import { ART_ORDERS_ROUTE, ART_ORDER_ROUTE, ArtOrderStatus } from "./constants";
import { ThemedIcon } from "../../Basic/Icon";
import { twMerge } from "tailwind-merge";
import { ArtOrderFull } from "@/api/art-order/types";
import { User } from "@/api/users/types";

export const endyIconByOrderStatus = (
  status: ArtOrderStatus,
  className?: string,
) => {
  switch (status) {
    case ArtOrderStatus.ACCEPTING_OFFERS:
      return (
        <ThemedIcon
          iconName="endy-waiting"
          className={twMerge("w-10 h-10", className)}
        />
      );
    case ArtOrderStatus.ACCEPTED:
      return (
        <ThemedIcon
          iconName="endy-ready"
          className={twMerge("w-10 h-10", className)}
        />
      );
    case ArtOrderStatus.DECLINED:
      return (
        <ThemedIcon
          iconName="endy-denied"
          className={twMerge("w-10 h-10", className)}
        />
      );
    case ArtOrderStatus.DELIVERED:
      return (
        <ThemedIcon
          iconName="endy"
          className={twMerge("w-10 h-10", className)}
        />
      );
  }
};

export const getArtOrderRouteById = (id: string) => {
  return `${ART_ORDER_ROUTE}/${id}`;
};

export const getArtOrderEditRouteById = (id: string) => {
  return `${ART_ORDER_ROUTE}/edit/${id}`;
};

export const getRouteForMyArtOrders = (page: number = 1) => {
  return `${ART_ORDERS_ROUTE}/my/${page}`;
};

export const shouldShowDeliveryPage = (
  artOrder: ArtOrderFull,
  user: User | null,
) => {
  return (
    user &&
    artOrder.acceptedOffer?.author?.id === user.id &&
    artOrder.status === ArtOrderStatus.ACCEPTED
  );
};

export const shouldShowConversationPage = (
  artOrder: ArtOrderFull,
  user: User | null,
) => {
  return (
    user &&
    artOrder.acceptedOffer &&
    (artOrder.author.id === user.id ||
      artOrder.acceptedOffer?.author?.id === user.id)
  );
};

export const shouldShowReviewPage = (
  artOrder: ArtOrderFull,
  user: User | null,
) => {
  return (
    user &&
    artOrder.status === ArtOrderStatus.DELIVERED &&
    user.id == artOrder.author.id
  );
};
